<template>
  <div>
    <iq-card v-if="corporation">
      <template v-slot:headerTitle>
        <h4 class="">
          {{ $t("colleges.colleges") }}
        </h4>
      </template>
      <template v-slot:headerAction>
        <b-button
          class="mr-1 float-right"
          @click="$refs.modalFormCollege.show()"
          variant="primary"
          >{{ $t("corporations.add-college") }}</b-button
        >
      </template>
      <template v-slot:body>
        <b-col md="12" class="table-responsive">
          <b-table
            class="table mb-0 table-borderless"
            :items="corporation.colleges"
            :fields="columns"
            :busy="
              !Array.isArray(corporation.colleges) ||
              corporation.colleges.length === 0
                ? true
                : false || isBusy == true
            "
          >
            <template v-slot:cell(commune)="data">
              {{ data.item.commune.name }}
            </template>
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <div v-if="isBusy">
                  <b-spinner type="grow" class="align-middle"></b-spinner>
                  <strong> Cargando datos...</strong>
                </div>
                <span class="h5" v-else>{{ $t("app.not-found") }}</span>
              </div>
            </template>

            <template v-slot:cell(action)="data">
              <b-button
                variant=" iq-bg-danger rounded"
                size="sm"
                @click="deleteItem(data.item.id)"
                ><i class="ri-delete-bin-line ml-1"></i
              ></b-button>
            </template>
          </b-table>
        </b-col>
      </template>
    </iq-card>
    <modal-form-college ref="modalFormCollege" />
  </div>
</template>
<script>
import { core } from "@/config/pluginInit";
import modalFormCollege from "./addCollege.vue";
import { mapActions, mapGetters } from "vuex";
import _ from "lodash";
export default {
  name: "CorporationColleges",
  components: {
    modalFormCollege,
  },
  methods: {
    ...mapActions({
      fetchCorporation: "fetchCorporation",
      deleteCorporationCollege: "deleteCorporationCollege",
    }),
    deleteItem(id) {
      this.$bvModal
        .msgBoxConfirm(this.$t("app.body-confirm-delete"), {
          title: this.$t("app.title-confirm-delete"),
          size: "sm",
          buttonSize: "sm",
          okVariant: "success rounded",
          cancelVariant: "outline-danger rounded",
          okTitle: this.$t("app.yes"),
          cancelTitle: this.$t("app.not"),
          headerClass: "text-center",
          bodyClass: "text-center text-danger",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            const resp = await this.deleteCorporationCollege({
              college_id: id,
              corporation_id: this.$route.params.id,
            });
            if (resp?.status == 200) {
              core.showSnackbar("success", resp.data.message);
            }
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
  },
  data() {
    return {
      isBusy: false,
    };
  },
  computed: {
    ...mapGetters({
      corporation: "corporation",
      corporationsLoading: "corporationsLoading",
    }),
    columns() {
      return [
        { label: this.$t("colleges.name"), key: "name", class: "text-left" },
        {
          label: this.$t("colleges.acronym"),
          key: "acronym",
          class: "text-left",
        },
        {
          label: this.$t("colleges.commune"),
          key: "commune",
          class: "text-left",
        },
        { label: this.$t("app.action"), key: "action", class: "text-center" },
      ];
    },
  },
};
</script>
<style>
.content-width {
  max-width: 460px !important;
}
</style>
